import { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { ENV_NAME, keycloak } from './lib'
import { VERSION } from './lib'
import { logError } from './lib'
import { createRoot } from 'react-dom/client'
import { getRedirectUrl } from './lib/authentication'
import './tailwind.css'

const mountNode = document.getElementById('root')
if (!mountNode) {
  throw new Error('Could not get #root element')
}

const environment = (
  <div className="container mx-auto">
    {VERSION} | {ENV_NAME}
  </div>
)

keycloak.init({ onLoad: 'login-required', redirectUri: getRedirectUrl() }).then(
  () => {
    const container = document.getElementById('root')
    const root = createRoot(container!)
    root.render(
      <StrictMode>
        <App doLogout={keycloak.logout} userToken={keycloak.token!} />
        {environment}
      </StrictMode>
    )
  },
  (err: any) => {
    if (err === 'Unauthenticated') {
      keycloak.login()
    } else {
      console.log('error authenticating, ', err)
      logError(new Error('Authentication failed'), err)

      ReactDOM.render(
        <div className="alert alert-danger">
          Wooopsie, authentication failed for some reason!
          {environment}
        </div>,
        mountNode
      )
    }
  }
)
